import { render, staticRenderFns } from "./organizationAgreement.vue?vue&type=template&id=6f2d4c21&"
import script from "./organizationAgreement.vue?vue&type=script&lang=js&"
export * from "./organizationAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports